import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '@shared/services/base.service';
import { Observable, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TaxInvoiceService extends BaseService {
  public override headers: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.receipts;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  public list(criteria): Observable<any> {
    const storeNo = this.retrieveStore().storeNo;
    const url = this.getFullUrl(this.envService.list, {
      storeNo
    });
    const params = this.getParams(criteria, true);

    return this.http
      .get<any>(url, {
        headers: this.loaderHeaders(null),
        observe: 'body',
        params
      })
      .pipe(
        map((res) => {
          if (res && res.content) {
            res.content.map((val) => {
              if (val.storeCode && val.storeName) {
                val.storeNameToDisplay = `${val.storeCode}-${val.storeName}`;
              }
            });
          }

          return res;
        })
      );
  }

  public detail(receiptNo): Observable<any> {
    const storeNo = this.retrieveStore().storeNo;
    const url = this.getFullUrl(this.envService.detail, {
      storeNo,
      receiptNo
    });

    return this.http
      .get<any>(url, {
        headers: this.loaderHeaders(null),
        observe: 'body'
      })
      .pipe(map((res) => res));
  }

  public agentTransactionDetail(receiptNo): Observable<any> {
    const storeNo = this.retrieveStore().storeNo;
    const url = this.getFullUrl(this.envService.agentTransactionDetail, {
      storeNo,
      receiptNo
    });

    return this.http
      .get<any>(url, {
        headers: this.loaderHeaders(null),
        observe: 'body'
      })
      .pipe(map((res) => res));
  }

  public create(request): Observable<any> {
    let storeNo = this.retrieveStore().storeNo;
    let receiptNo = request.receiptNo;

    const url = this.getFullUrl(this.envService.create, {
      storeNo,
      receiptNo
    });

    return this.http.post<any>(url, request, {
      headers: this.loaderHeaders(3000),
      observe: 'response',
      responseType: 'blob' as 'json'
    });
  }

  public cancelAndCreate(oldInvoiceNo, cancelTaxId, request): Observable<any> {
    const storeNo = this.retrieveStore().storeNo;

    const url = this.getFullUrl(this.envService.cancelAndCreate, {
      storeNo
    });

    const body = {
      taxInvoiceNo: oldInvoiceNo,
      cancelTaxId: cancelTaxId,
      createTaxInvoiceRequest: request
    };

    return this.http.post<any>(url, body, {
      headers: this.loaderHeaders(3000),
      observe: 'response',
      responseType: 'blob' as 'json'
    });
  }

  public print(request): Observable<any> {
    let storeNo = this.retrieveStore().storeNo;

    const url = this.getFullUrl(this.envService.reprint, {
      storeNo
    });

    return this.http.post<any>(url, request, {
      headers: this.loaderHeaders(),
      observe: 'response',
      responseType: 'blob' as 'json'
    });
  }

  public cancel(request): Observable<any> {
    let storeNo = this.retrieveStore().storeNo;

    const url = this.getFullUrl(this.envService.cancel, {
      storeNo
    });

    return this.http.post<any>(url, request, {
      headers: this.loaderHeaders(),
      observe: 'body'
    });
  }

  public validateCancel(request): Observable<any> {
    let storeNo = this.retrieveStore().storeNo;
    const url = this.getFullUrl(this.envService.validateCancel, {
      storeNo
    });
    return this.http.post<any>(url, request, {
      headers: this.loaderHeaders(),
      observe: 'body'
    });
  }

  public validate(receiptNo): Observable<any> {
    let storeNo = this.retrieveStore().storeNo;
    const url = this.getFullUrl(this.envService.validate, {
      storeNo,
      receiptNo
    });

    return this.http
      .get<any>(url, {
        headers: this.loaderHeaders(),
        observe: 'body'
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  public rePrintValidate(receiptNo): Observable<any> {
    let storeNo = this.retrieveStore().storeNo;
    const url = this.getFullUrl(this.envService.rePrintValidate, {
      storeNo,
      receiptNo
    });

    return this.http
      .get<any>(url, {
        headers: this.loaderHeaders(),
        observe: 'body'
      })
      .pipe(
        map((res) => {
          return res;
        })
      );
  }

  public printCreditNote(request): Observable<any> {
    let storeNo = this.retrieveStore().storeNo;
    const url = this.getFullUrl(this.envService.printCreditNote, {
      storeNo
    });

    return this.http.post<any>(url, request, {
      headers: this.loaderHeaders(3000),
      observe: 'response',
      responseType: 'blob' as 'json'
    });
  }
}
